import type {
  SessionResult,
  PostSessionRequest,
  PostSessionResponse,
  GetLeaderboardResponse,
  Language,
} from '@codedrill/shared';
import { apiFetch } from './client';

export async function postSession(result: SessionResult): Promise<PostSessionResponse> {
  const body: PostSessionRequest = { result };
  return apiFetch<PostSessionResponse>('/sessions', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export async function fetchLeaderboard(
  language?: Language,
  period: 'daily' | 'weekly' | 'alltime' = 'alltime',
  limit = 25,
): Promise<GetLeaderboardResponse> {
  const params = new URLSearchParams();
  if (language) params.set('language', language);
  params.set('period', period);
  params.set('limit', String(limit));

  return apiFetch<GetLeaderboardResponse>(`/leaderboard?${params}`);
}
